import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { addRating } from '../../../../slices/postSlice';
import { setAlert } from '../../../../slices/alertSlice';
import RatePostForm from './RatePostForm';
import * as Yup from 'yup';

//constants

const EnhancedRatePostForm = withFormik({
  mapPropsToValues: (props) => ({
    rating: '',
  }),
  validationSchema: Yup.object().shape({
    rating: Yup.number().required('Rating is required!'),
  }),
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    const {
      addRating,
      setOpenModal,
      setAlert,
      post: { post },
    } = props;
    if (values.rating === '') {
    } else {
      addRating(values, post.post);
      // console.log(values);
    }
    setOpenModal(false);
    setSubmitting(false);
    resetForm({ rating: '' });
  },
  displayName: 'RatePostForm',
})(RatePostForm);

const mapStateToProps = (state) => ({
  post: state.post,
});

export default connect(mapStateToProps, { addRating, setAlert })(
  EnhancedRatePostForm
);
